import {Injectable, inject} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthenticationService} from '../auth';
import {ErrorService} from '../services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly _authenticationService = inject(AuthenticationService);
  private readonly _errorService = inject(ErrorService);
  /**
   * Intercept all HTTP requests and handle error response
   */
  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<HttpErrorResponse>> {
    return next.handle(request).pipe(
      catchError((httpError: HttpErrorResponse) => {
        if (httpError.status === 401) {
          /** Auto logout if 401 response returned from api */
          this._authenticationService.logout();
        } else {
          this._errorService.errorHandler(httpError);
        }
        return throwError(() => httpError);
      })
    );
  }
}
